<template>
    <div>
        <b-modal v-model="show_delete" title="Delete program" @ok="deleteCourse" cancel-title="No" ok-title="Yes">
            <div v-if="course_to_delete != null">
                <p class="mb-2">
                    Are you sure you want to delete the program {{ course_to_delete.name }}?
                </p>

                <p>Type <strong>DELETE</strong> and click on <i>Yes</i> to delete the program</p>

                <div class="input-content">
                    <input type="text" v-model="safe_word" placeholder="Type DELETE to delete the program" class="strong"/>

                    <span class="input-error-msg">{{ safe_word_message }}</span>
                </div>
			</div>
		</b-modal>

        <b-modal v-model="show_duplicate" title="Duplicate program" @ok="duplicateCourse" cancel-title="No" ok-title="Yes">
            <div v-if="course_to_duplicate != null">
                <p v-if="module_duplicate" class="mb-2">
                    Are you sure you want to duplicate the program {{ getModuleName() }}?
                </p>
                <p v-else class="mb-2">
                    Are you sure you want to duplicate the program {{ course_to_duplicate.name }}?
                </p>
                <p>
                    All the lessons are  <span v-if="!module_duplicate">modules</span> will be copied too. 
                </p>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    props:['show_duplicate_course','show_delete_course','course_to_duplicate','course_to_delete','module_duplicate'],
    data:function(){
        return{
            safe_word:'',
            safe_word_message:''
        }
    },
   computed: {
        show_delete: {
            get () { return this.show_delete_course },
            set (value) {  },
        },
        show_duplicate: {
            get () { return this.show_duplicate_course },
            set (value) {  },
        }
        
    },
    methods:{
        deleteCourse: function(event){
				if(this.safe_word == 'DELETE'){
					var params = {
						id : this.course_to_delete.id
					}
					this.$store.dispatch('deleteCourse', params).then((res) => {
                    this.safe_word = ''
					this.$emit('deleteCourse')
                    this.closeModals()

					}).catch((error) => {
						console.log(error);
					});
				}else{
					this.safe_word_message = 'You have to type DELETE';
					event.preventDefault();
				}
            
        },
        duplicateCourse: function(){
            if(this.module_duplicate){
                this.duplicateModule()
                return
            }
            var params = {
                id : this.course_to_duplicate.id
            }
            this.$store.dispatch('duplicateCourse', params).then((res) => {
                var course_id = params.id;
                let routeData = this.$router.resolve({ name : 'sme.courses.copy-log', params : { id : course_id, hash : res.data.hash}});
                this.closeModals()
                window.open(routeData.href, '_blank');
               
            }).catch((error) => {
                console.log(error);
            });
             this.$emit('duplicateCourse')
		},
        duplicateModule: function(){
            var params = {
                id : this.course_to_duplicate.id
            }
            this.$store.dispatch('duplicateModule', params).then((res) => {
                console.log(res)
                // var course_id = params.id;
                // let routeData = this.$router.resolve({ name : 'sme.courses.copy-log', params : { id : course_id, hash : res.data.hash}});
                // window.open(routeData.href, '_blank');
               this.closeModals()
            }).catch((error) => {
                console.log(error);
            });
             this.$emit('duplicateCourse')
		},
        getModuleName(){
            if(this.course_to_duplicate.name && this.course_to_duplicate.name['EN']){
                return  this.course_to_duplicate.name['EN']
            }else{
                return this.course_to_duplicate.title
            }
        
        },
        closeModals(){
            this.$emit('cleanModals')
        }
        
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/sme/SharedViews/SMEModalsView.vue